import restService from "../rest-service/RestService";
import { IEditDTO, IReferenceDTO, ISummaryDTO, defaultEditAlarmScheme  } from "./Models";

const AlarmSchemeAdministrationDataService = {

    getAlarmScheme: async function (
        organizationID: number,
        groupID: number,
        alarmSchemeID: number,
        signal?: AbortSignal
    ): Promise<IEditDTO> {

        if (alarmSchemeID > 0) {
            const path = `/groups/${groupID}/organizations/${organizationID}/alarmSchemes/${alarmSchemeID}`;
            const response = await restService.get<IEditDTO>(path, signal);
            return response.data;
        }

         const alarmScheme: IEditDTO = {
            ...defaultEditAlarmScheme
         };

         return alarmScheme;

    },
    getReferenceData: async function (groupID: number,
        organizationID: number,
        signal?: AbortSignal
    ) : Promise<IReferenceDTO> {

        const path = `/groups/${groupID}/organizations/${organizationID}/alarmSchemes/referenceData`;

        const response = await restService.get<IReferenceDTO>(path, signal);
        return response.data;
    },
    saveAlarmScheme: async function (organizationID: number,
        groupID: number,
        scheme: IEditDTO
    ) : Promise<IEditDTO> {
        const path = `/groups/${groupID}/organizations/${organizationID}/alarmSchemes`;

        const response = await restService.post<IEditDTO, IEditDTO>(path, scheme);
        return response.data;
    },
    getAlarmSchemes: async function (organizationID: number,
        groupID: number,
        signal?: AbortSignal
        ) : Promise<ISummaryDTO[]> {

        const path = `/groups/${groupID}/organizations/${organizationID}/alarmSchemes`;

        const response = await restService.get<ISummaryDTO[]>(path, signal);
        return response.data;
    },
    deleteAlarmScheme: async function (organizationID: number,
        groupID: number,
        alarmSchemeID: number) : Promise<void> {

        const path = `/groups/${groupID}/organizations/${organizationID}/alarmSchemes/${alarmSchemeID}`;
        await restService.delete<void>(path);

    }

// deleteAlarmScheme(groupId: number, organizationId: number, alarmSchemeId: number)
// : Services.RestPromise<any> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/alarmSchemes/{alarmSchemeID:int}"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "alarmSchemes",
//     alarmSchemeId
// ].join("/");

// return this._restService
//     .delete(path)
//     .then((data) => { return data });

// }

// getAlarmSchemes(groupId: number, organizationId: number)
// : Services.RestPromise<Array<AlarmSchemeModels.ISummaryDTO>> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/alarmSchemes"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "alarmSchemes"
// ].join("/");

// return this._restService
//     .get<Array<AlarmSchemeModels.ISummaryDTO>>(path)
//     .then((data) => { return data.entity; });

// }


// saveAlarmScheme(groupId: number, organizationId: number, alarmScheme: AlarmSchemeModels.IEditDTO)
// : Services.RestPromise<AlarmSchemeModels.IEditDTO> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/alarmSchemes"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "alarmSchemes"
// ].join("/");

// return this._restService
//     .post<AlarmSchemeModels.IEditDTO, AlarmSchemeModels.IEditDTO>(path, alarmScheme)
//     .then((data) => { return data.entity });

// }


    // getReferenceData(groupId: number, organizationId: number)
// : Services.RestPromise<AlarmSchemeModels.IReferenceDTO> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/alarmSchemes/referenceData"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "alarmSchemes",
//     "referenceData"
// ].join("/");

// return this._restService
//     .get<AlarmSchemeModels.IReferenceDTO>(path)
//     .then((data) => { return data.entity; });

// }



};

export default AlarmSchemeAdministrationDataService;




// saveAlarmScheme(groupId: number, organizationId: number, alarmScheme: AlarmSchemeModels.IEditDTO)
// : Services.RestPromise<AlarmSchemeModels.IEditDTO> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/alarmSchemes"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "alarmSchemes"
// ].join("/");

// return this._restService
//     .post<AlarmSchemeModels.IEditDTO, AlarmSchemeModels.IEditDTO>(path, alarmScheme)
//     .then((data) => { return data.entity });

// }
